import { User } from '../types';

/** Canonical UserProfile.Id. Never fall back to IDUserId — it is not unique across profiles. */
export function getUserProfileId(user: User | null | undefined): number | undefined {
  return user?.id;
}
